import { getNewbuildingChatContacts } from '@cian/newbuilding-chat-component';
import { createSelector } from '@reduxjs/toolkit';

import { getBuilders, getSellers } from '../newbuilding';

export const getBuilderChatEnabled = createSelector(getBuilders, getSellers, (builders, sellers) => {
  const chatContacts = getNewbuildingChatContacts(builders, sellers);

  return chatContacts.length > 0;
});
